module.exports = __webpack_public_path__ + "img/olympics-icon-white.c36f02d6.png";